import Vuex from 'vuex'
import Vue from 'vue'

import { getTables } from '@/api.js'

Vue.use(Vuex)

// setup Vue store
const store = new Vuex.Store({
  state: {
    planAvailable: false,
    treenodes: {},
    neuralAvailable: false,
    email: "",
    db: "tpch",
    // rdbms: "PostgreSQL",
    // showTree: false,
    tables: [],
    curSql: "",
    pooldb: "pool",
    exampleSqls: {
      tpch: [`select 
      l_returnflag,
      l_linestatus,
      sum(l_quantity) as sum_qty,
      sum(l_extendedprice) as sum_base_price,
      sum(l_extendedprice * (1 - l_discount)) as sum_disc_price,
      sum(l_extendedprice * (1 - l_discount) * (1 + l_tax)) as sum_charge,
      avg(l_quantity) as avg_qty,
      avg(l_extendedprice) as avg_price,
      avg(l_discount) as avg_disc,
      count(*) as count_order
    from
      lineitem
    where
      l_extendedprice > 100
    group by
      l_returnflag,
      l_linestatus
    order by
      l_returnflag,
      l_linestatus;`,
        `select
      l_orderkey,
      sum(l_extendedprice * (1 - l_discount)) as revenue,
      o_orderdate,
      o_shippriority
    from
      customer,
      orders,
      lineitem
    where
      c_mktsegment = 'BUILDING'
      and c_custkey = o_custkey
      and l_orderkey = o_orderkey
      and o_totalprice > 10
      and l_extendedprice > 10
    group by
      l_orderkey,
      o_orderdate,
      o_shippriority
    order by
      revenue desc,
      o_orderdate;`,

        `select
      o_orderpriority,
      count(*) as order_count
    from
      orders
    where
      o_totalprice > 100
      and exists (
        select
          *
        from
          lineitem
        where
          l_orderkey = o_orderkey
          and l_extendedprice > 100
      )
    group by
      o_orderpriority
    order by
      o_orderpriority;`,

        `select
      n_name,
      sum(l_extendedprice * (1 - l_discount)) as revenue
    from
      customer,
      orders,
      lineitem,
      supplier,
      nation,
      region
    where
      c_custkey = o_custkey
      and l_orderkey = o_orderkey
      and l_suppkey = s_suppkey
      and c_nationkey = s_nationkey
      and s_nationkey = n_nationkey
      and n_regionkey = r_regionkey
      and r_name = 'ASIA'
      and o_orderdate >= '1994-01-01'
      and o_orderdate < '1995-01-01'
      and c_acctbal > 10
      and s_acctbal > 20
    group by
      n_name
    order by
      revenue desc;`,

        `select
      sum(l_extendedprice * l_discount) as revenue
    from
      lineitem
    where
                l_extendedprice > 100;`,

        `select
      supp_nation,
      cust_nation,
      l_year,
      sum(volume) as revenue
    from
      (
        select
          n1.n_name as supp_nation,
          n2.n_name as cust_nation,
          DATE_PART('YEAR',l_shipdate) as l_year,
          l_extendedprice * (1 - l_discount) as volume
        from
          supplier,
          lineitem,
          orders,
          customer,
          nation n1,
          nation n2
        where
          s_suppkey = l_suppkey
          and o_orderkey = l_orderkey
          and c_custkey = o_custkey
          and s_nationkey = n1.n_nationkey
          and c_nationkey = n2.n_nationkey
          and (
            (n1.n_name = 'FRANCE' and n2.n_name = 'GERMANY')
            or (n1.n_name = 'GERMANY' and n2.n_name = 'FRANCE')
          )
          and l_shipdate between '1995-01-01' and '1996-12-31'
          and o_totalprice > 100
          and c_acctbal > 10
      ) as shipping
    group by
      supp_nation,
      cust_nation,
      l_year
    order by
      supp_nation,
      cust_nation,
      l_year;`,
        `select
      o_year,
      sum(case
        when nation = 'BRAZIL' then volume
        else 0
      end) / sum(volume) as mkt_share
    from
      (
        select
          DATE_PART('YEAR',o_orderdate) as o_year,
          l_extendedprice * (1 - l_discount) as volume,
          n2.n_name as nation
        from
          part,
          supplier,
          lineitem,
          orders,
          customer,
          nation n1,
          nation n2,
          region
        where
          p_partkey = l_partkey
          and s_suppkey = l_suppkey
          and l_orderkey = o_orderkey
          and o_custkey = c_custkey
          and c_nationkey = n1.n_nationkey
          and n1.n_regionkey = r_regionkey
          and r_name = 'AMERICA'
          and s_nationkey = n2.n_nationkey
          and o_orderdate between '1995-01-01' and '1996-12-31'
          and p_type = 'ECONOMY ANODIZED STEEL'
          and s_acctbal > 10
          and l_extendedprice > 100
      ) as all_nations
    group by
      o_year
    order by
      o_year;`,


        `select
      n_name,
      o_year,
      sum(amount) as sum_profit
    from
      (
        select
          n_name,
          DATE_PART('YEAR',o_orderdate) as o_year,
          l_extendedprice * (1 - l_discount) - ps_supplycost * l_quantity as amount
        from
          part,
          supplier,
          lineitem,
          partsupp,
          orders,
          nation
        where
          s_suppkey = l_suppkey
          and ps_suppkey = l_suppkey
          and ps_partkey = l_partkey
          and p_partkey = l_partkey
          and o_orderkey = l_orderkey
          and s_nationkey = n_nationkey
          and p_name like '%green%'
          and s_acctbal > 10
          and ps_supplycost > 100
      ) as profit
    group by
      n_name,
      o_year
    order by
      n_name,
      o_year desc;`,


        `select
      c_custkey,
      c_name,
      sum(l_extendedprice * (1 - l_discount)) as revenue,
      c_acctbal,
      n_name,
      c_address,
      c_phone,
      c_comment
    from
      customer,
      orders,
      lineitem,
      nation
    where
      c_custkey = o_custkey
      and l_orderkey = o_orderkey
      and o_orderdate >= '1993-10-01'
      and o_orderdate < '1994-01-01'
      and c_nationkey = n_nationkey
      and c_acctbal > 10
      and l_extendedprice > 100
    group by
      c_custkey,
      c_name,
      c_acctbal,
      c_phone,
      n_name,
      c_address,
      c_comment
    order by
      revenue desc;`,

        `select
      ps_partkey,
      sum(ps_supplycost * ps_availqty) as value
    from
      partsupp,
      supplier,
      nation
    where
      ps_suppkey = s_suppkey
      and s_nationkey = n_nationkey
      and n_name = 'GERMANY'
      and ps_supplycost > 20
      and s_acctbal > 10
    group by
      ps_partkey having
        sum(ps_supplycost * ps_availqty) > (
          select
            sum(ps_supplycost * ps_availqty) * 0.0001000000
          from
            partsupp,
            supplier,
            nation
          where
            ps_suppkey = s_suppkey
            and s_nationkey = n_nationkey
            and n_name = 'GERMANY'
        )
    order by
      value desc;`
      ],
      imdb: [
        `SELECT COUNT(*) FROM title, genre WHERE title.titlekey = genre.titlekey`,
        `SELECT MIN(runtimeminutes) FROM title,person,crew WHERE title.titlekey = crew.titlekey AND person.namekey = crew.namekey AND person.primaryname = 'Chincheta' AND title.titletype = 'kung fu' AND title.titlekey= 'Crouching Tiger, Hidden Dragon' AND  person.namekey = 'Michael' AND crew.ordering = 955 AND person.birthyear = 1983`,
        `SELECT SUM(startyear) FROM title,genre WHERE title.titlekey = genre.titlekey AND title.startyear = 2000 AND title.titlekey = 'Crouching Tiger, Hidden Dragon' AND title.titletype = 'kung fu'`,
        `SELECT SUM(startyear) FROM title,genre WHERE title.titlekey = genre.titlekey AND startyear = 2000 AND title.titlekey = 'Crouching Tiger, Hidden Dragon' AND titletype = 'kung fu'`,
        `SELECT COUNT(*) FROM rating,title WHERE title.titlekey = rating.titlekey AND titletype = 'kung fu' AND startyear = 2000`,
        `SELECT MAX(runtimeminutes) FROM knowntitle,title,person WHERE title.titlekey = knowntitle.knowntitle AND person.namekey = knowntitle.namekey AND person.namekey = 'kung fu'`,
        `SELECT MAX(deathyear) FROM person,crewcharacter,crew,title WHERE crew.ordering = crewcharacter.ordering AND title.titlekey = crew.titlekey AND person.namekey = crew.namekey AND birthyear = '1983' AND titletype = 'kung fu'`,
        `SELECT MAX(startyear) FROM title,episode WHERE title.titlekey = episode.titlekey AND startyear = 2000`,
        `SELECT MAX(startyear) FROM title,episode WHERE title.titlekey = episode.titlekey AND title.titlekey = 'Crouching Tiger, Hidden Dragon' AND title.titletype = 'kung fu' AND episode .episodenumber = 7`,
        `SELECT COUNT(*) FROM profession,person WHERE person.namekey = profession.namekey AND person .namekey = 'Michael' AND person .primaryname = 'Chincheta' AND birthyear = '1983'`,
        // `SELECT SUM(directors.id) FROM movies, directors,movies_directors WHERE directors.id = movies_directors.director_id AND movies.id = movies_directors.movie_id AND movie_id = 60570 AND first_name = 'Todd' AND director_id = 2 AND last_name = '12 Poissons'`,
        // `SELECT SUM(id) FROM directors,directors_genres WHERE directors.id = directors_genres.directors_id AND prob < 1 AND last_name = '12 Poissons'`,
        // `SELECT MAX(rank) FROM actors, movies,roles WHERE movies.id = roles.movie_id AND actors.id = roles.actor_id AND rank = 5 AND role = 'wer' AND rank is null`,
        // `SELECT MIN(rank) FROM movies,movies_genres WHERE movies.id = movies_genres.movie_id AND name = '$1,000 Reward'`,
        // `SELECT MAX(movie_id) FROM directors, movies, movies_directors WHERE movies.id = movies_directors.movie_id AND directors.id = movies_directors.director_id AND movie_id = 60570 AND director_id = 2`,
        // `SELECT MIN(movie_id) FROM movies_genres,movies WHERE movies.id = movies_genres.movie_id AND name = '$1,000 Reward' AND year = 1915`,
        // `SELECT SUM(director_id) FROM directors, movies, movies_directors WHERE movies.id = movies_directors.movie_id AND directors.id = movies_directors.director_id AND movie_id = 60570 AND director_id = 2`,
        // `SELECT MAX( actors.id ) FROM actors,roles,movies WHERE actors.id = roles.actor_id AND movies.id = roles.movie_id AND rank = 5 AND first_name = 'Michael' AND role = 'wer' AND year = 1915 AND year > 1915 AND last_name = 'Chincheta'`,
        // `SELECT COUNT(*) FROM roles,movies WHERE movies.id = roles.movie_id AND actors.id = roles.actor_id AND rank = 5 AND rank is null`,
        // `SELECT SUM(directors.id ) FROM movies, directors,movies_directors WHERE directors.id = movies_directors.director_id AND movies.id = movies_directors.movie_id AND movie_id = 60570 AND last_name = '12 Poissons' AND first_name = 'Todd' AND director_id = 2`,
        // `SELECT MIN(movie_id) FROM directors, movies, movies_directors WHERE movies.id = movies_directors.movie_id AND directors.id = movies_directors.director_id AND movie_id = 60570`,
        // `SELECT MAX(id) FROM directors,directors_genres WHERE directors.id = directors_genres.directors_id AND prob < 1 AND first_name = 'Todd'`,
        // `SELECT SUM(director_id) FROM movies,movies_directors,directors WHERE directors.id = movies_directors.director_id AND movies.id = movies_directors.movie_id AND last_name = '12 Poissons' AND movie_id = 60570 AND first_name = 'Todd'`,
        // `SELECT MIN(director_id ) FROM directors,movies,movies_directors WHERE directors.id = movies_directors.director_id AND movies.id = movies_directors.movie_id AND name = '$1,000 Reward' AND first_name = 'Todd' AND rank is null AND director_id = 2 AND rank = 5 AND year > 1915 AND year = 1915 AND last_name = '12 Poissons' AND movie_id = 60570`,
        // `SELECT COUNT(*) FROM movies_genres,movies WHERE movies.id = movies_genres.movie_id AND year = 1915 AND name = '$1,000 Reward' AND rank = 5 AND rank is null AND year > 1915`,
        // `SELECT SUM(movie_id) FROM movies_genres,movies WHERE movies.id = movies_genres.movie_id AND rank is null AND year = 1915 AND rank = 5 AND name = '$1,000 Reward' AND year > 1915`,
        // `SELECT SUM(rank) FROM movies,actors,roles WHERE movies.id = roles.movie_id AND actors.id = roles.actor_id AND year = 1915 AND last_name = 'Chincheta' AND year > 1915`,
        // `SELECT SUM(movie_id) FROM movies_genres,movies WHERE movies.id = movies_genres.movie_id AND name = '$1,000 Reward'`,
        // `SELECT SUM(id) FROM directors,movies,movies_directors WHERE movies.id = movies_directors.movie_id AND directors.id = movies_directors.director_id AND movie_id = 60570 AND rank is null AND last_name = '12 Poissons'`,
        // `SELECT SUM(movie_id) FROM movies_genres,movies WHERE movies.id = movies_genres.movie_id AND year > 1915 AND rank is null AND year = 1915`,
        // `SELECT MIN(id) FROM directors,movies_directors,movies WHERE directors.id = movies_directors.director_id AND movies.id = movies_directors.movie_id AND year = 1915 AND year > 1915 AND name = '$1,000 Reward' AND director_id = 2 AND rank is null AND rank = 5 AND last_name = '12 Poissons' AND movie_id = 60570`,
        // `SELECT SUM(year) FROM movies,movies_directors WHERE movies.id = movies_directors.movie_id AND directors.id = movies_directors.director_id AND movie_id = 60570`,
        // `SELECT MAX(id) FROM actors,roles WHERE actors.id = roles.actor_id AND movies.id = roles.movie_id AND gender = 'M' AND role = 'wer' AND first_name = 'Michael' AND last_name = 'Chincheta'`,
        // `SELECT SUM(actor_id) FROM roles,actors,movies WHERE actors.id = roles.actor_id AND movies.id = roles.movie_id AND gender = 'M'`,
        // `SELECT COUNT(*) FROM movies_genres,movies WHERE movies.id = movies_genres.movie_id AND year > 1915 AND rank = 5 AND year = 1915 AND rank is null`,
        // `SELECT MAX(movie_id) FROM movies_genres,movies WHERE movies.id = movies_genres.movie_id AND year > 1915 AND year = 1915 AND rank is null AND rank = 5 AND name = '$1,000 Reward'`,
        // `SELECT COUNT(*) FROM directors_genres,directors WHERE directors.id = directors_genres.directors_id AND last_name = '12 Poissons' AND genre = 'Drama'`,
        // `SELECT COUNT(*) FROM movies_genres,movies WHERE movies.id = movies_genres.movie_id AND year > 1915 AND rank = 5 AND year = 1915 AND name = '$1,000 Reward' AND rank is null`,
        // `SELECT SUM(rank) FROM movies,movies_genres WHERE movies.id = movies_genres.movie_id AND rank is null AND year = 1915 AND year > 1915`,
        // `SELECT SUM(year) FROM movies,movies_directors,directors WHERE movies.id = movies_directors.movie_id AND directors.id = movies_directors.director_id AND year = 1915 AND first_name = 'Todd' AND movie_id = 60570 AND rank is null AND year > 1915`,
        // `SELECT MIN(director_id) FROM movies_directors,movies WHERE movies.id = movies_directors.movie_id AND directors.id = movies_directors.director_id AND year = 1915 AND movie_id = 60570 AND rank = 5 AND name = '$1,000 Reward' AND rank is null AND year > 1915`,
        // `SELECT MIN(rank) FROM movies,movies_genres WHERE movies.id = movies_genres.movie_id AND year = 1915 AND name = '$1,000 Reward'`,
        // `SELECT MIN(actor_id) FROM roles,movies WHERE movies.id = roles.movie_id AND actors.id = roles.actor_id AND rank is null AND role = 'wer' AND year = 1915 AND name = '$1,000 Reward'`,
        // `SELECT SUM(directors_id) FROM directors_genres,directors WHERE directors.id = directors_genres.directors_id AND prob < 1 AND last_name = '12 Poissons' AND genre = 'Drama'`,
        // `SELECT SUM(id) FROM movies,roles WHERE movies.id = roles.movie_id AND actors.id = roles.actor_id AND name = '$1,000 Reward' AND year = 1915 AND rank = 5 AND rank is null`,
        // `SELECT MIN(id) FROM actors,movies,roles WHERE movies.id = roles.movie_id AND actors.id = roles.actor_id AND name = '$1,000 Reward' AND year > 1915 AND year = 1915 AND rank = 5 AND gender = 'M' AND first_name = 'Michael' AND last_name = 'Chincheta' AND role = 'wer' AND rank is null`,
        // `SELECT MIN(director_id) FROM movies_directors,movies WHERE movies.id = movies_directors.movie_id AND directors.id = movies_directors.director_id AND name = '$1,000 Reward' AND year = 1915 AND year > 1915 AND movie_id = 60570`,
        // `SELECT MAX(actor_id) FROM roles,actors WHERE actors.id = roles.actor_id AND movies.id = roles.movie_id AND first_name = 'Michael'`,
        // `SELECT SUM(prob) FROM directors_genres WHERE directors.id = directors_genres.directors_id AND prob < 1`,
        // `SELECT SUM(id) FROM directors,movies,movies_directors WHERE directors.id = movies_directors.director_id AND movies.id = movies_directors.movie_id AND year = 1915 AND rank is null AND year > 1915 AND first_name = 'Todd' AND director_id = 2 AND movie_id = 60570 AND rank = 5`,
        // `SELECT SUM(year) FROM movies,movies_directors,directors WHERE movies.id = movies_directors.movie_id AND directors.id = movies_directors.director_id AND year = 1915 AND name = '$1,000 Reward'`,
        // `SELECT COUNT(*) FROM directors_genres,directors WHERE directors.id = directors_genres.directors_id AND last_name = '12 Poissons'`,
        // `SELECT MIN(director_id) FROM movies_directors,directors,movies WHERE movies.id = movies_directors.movie_id AND directors.id = movies_directors.director_id AND name = '$1,000 Reward' AND movie_id = 60570 AND first_name = 'Todd' AND rank is null AND last_name = '12 Poissons' AND year = 1915 AND rank = 5 AND director_id = 2`,
        // `SELECT MAX(directors_id) FROM directors_genres,directors WHERE directors.id = directors_genres.directors_id AND prob < 1 AND first_name = 'Todd'`,
        // `SELECT COUNT(*) FROM roles,actors WHERE actors.id = roles.actor_id AND movies.id = roles.movie_id AND gender = 'M' AND first_name = 'Michael' AND last_name = 'Chincheta'`,
        // `SELECT COUNT(*) FROM movies_directors,movies WHERE movies.id = movies_directors.movie_id AND directors.id = movies_directors.director_id AND movie_id = 60570`,
        // `SELECT MAX(id) FROM movies,movies_directors,directors WHERE directors.id = movies_directors.director_id AND movies.id = movies_directors.movie_id AND rank = 5 AND first_name = 'Todd' AND name = '$1,000 Reward' AND year = 1915`,
        // `SELECT MIN(id) FROM directors,movies_directors,movies WHERE movies.id = movies_directors.movie_id AND directors.id = movies_directors.director_id AND name = '$1,000 Reward'`,
        // `SELECT MAX(prob) FROM directors_genres,directors WHERE directors.id = directors_genres.directors_id AND first_name = 'Todd' AND last_name = '12 Poissons'`,
        // `SELECT COUNT(*) FROM directors_genres,directors WHERE directors.id = directors_genres.directors_id AND genre = 'Drama' AND last_name = '12 Poissons'`,
        // `SELECT MIN(year) FROM movies,movies_genres WHERE movies.id = movies_genres.movie_id AND name = '$1,000 Reward' AND year = 1915 AND year > 1915 AND rank is null`,
        // `SELECT MAX(prob) FROM directors_genres,directors WHERE directors.id = directors_genres.directors_id AND last_name = '12 Poissons' AND prob < 1 AND genre = 'Drama'`,
        // `SELECT MIN(id) FROM actors,roles,movies WHERE movies.id = roles.movie_id AND actors.id = roles.actor_id AND last_name = 'Chincheta' AND role = 'wer' AND year = 1915`,
        // `SELECT MIN(rank) FROM movies,actors,roles WHERE movies.id = roles.movie_id AND actors.id = roles.actor_id AND rank is null AND last_name = 'Chincheta' AND year = 1915 AND rank = 5 AND year > 1915 AND name = '$1,000 Reward' AND first_name = 'Michael'`,
        // `SELECT SUM(actor_id) FROM roles,actors WHERE actors.id = roles.actor_id AND movies.id = roles.movie_id AND gender = 'M' AND first_name = 'Michael' AND last_name = 'Chincheta'`,
        // `SELECT MAX(rank) FROM movies,movies_genres WHERE movies.id = movies_genres.movie_id AND rank = 5`,
        // `SELECT MAX(actor_id) FROM roles,movies,actors WHERE movies.id = roles.movie_id AND actors.id = roles.actor_id AND year = 1915 AND last_name = 'Chincheta' AND role = 'wer' AND rank = 5 AND year > 1915 AND first_name = 'Michael' AND gender = 'M'`,
        // `SELECT COUNT(*) FROM roles,movies WHERE movies.id = roles.movie_id AND actors.id = roles.actor_id AND year = 1915 AND rank = 5 AND rank is null AND name = '$1,000 Reward'`,
        // `SELECT MAX(prob) FROM directors_genres,directors WHERE directors.id = directors_genres.directors_id AND genre = 'Drama' AND first_name = 'Todd'`,
        // `SELECT COUNT(*) FROM movies_directors,movies WHERE movies.id = movies_directors.movie_id AND directors.id = movies_directors.director_id AND director_id = 2 AND movie_id = 60570 AND year = 1915 AND rank is null AND rank = 5 AND name = '$1,000 Reward' AND year > 1915`,
        // `SELECT MAX(actor_id) FROM roles WHERE movies.id = roles.movie_id AND actors.id = roles.actor_id AND role = 'wer'`,
        // `SELECT COUNT(*) FROM roles,actors WHERE actors.id = roles.actor_id AND movies.id = roles.movie_id AND first_name = 'Michael' AND last_name = 'Chincheta' AND gender = 'M' AND role = 'wer'`,
        // `SELECT SUM(director_id) FROM movies_directors WHERE directors.id = movies_directors.director_id AND movies.id = movies_directors.movie_id AND director_id = 2`,
        // `SELECT MAX(rank) FROM movies,directors,movies_directors WHERE directors.id = movies_directors.director_id AND movies.id = movies_directors.movie_id AND rank is null AND director_id = 2 AND rank = 5 AND year = 1915 AND year > 1915 AND movie_id = 60570 AND name = '$1,000 Reward'`,
        // `SELECT SUM(year) FROM movies,roles WHERE movies.id = roles.movie_id AND actors.id = roles.actor_id AND rank is null`,
        // `SELECT MAX(movie_id) FROM movies_genres,movies WHERE movies.id = movies_genres.movie_id AND rank = 5 AND name = '$1,000 Reward' AND rank is null AND year > 1915 AND year = 1915`,
        // `SELECT MAX(id) FROM directors,movies,movies_directors WHERE movies.id = movies_directors.movie_id AND directors.id = movies_directors.director_id AND movie_id = 60570 AND first_name = 'Todd' AND rank = 5 AND year = 1915 AND last_name = '12 Poissons' AND director_id = 2`,
        // `SELECT MIN(movie_id) FROM movies_directors,directors,movies WHERE directors.id = movies_directors.director_id AND movies.id = movies_directors.movie_id AND first_name = 'Todd' AND name = '$1,000 Reward'`,
        // `SELECT SUM(rank) FROM movies,movies_directors WHERE movies.id = movies_directors.movie_id AND directors.id = movies_directors.director_id AND rank = 5 AND movie_id = 60570 AND name = '$1,000 Reward' AND year > 1915`,
        // `SELECT MAX(id) FROM directors,directors_genres WHERE directors.id = directors_genres.directors_id AND prob < 1 AND first_name = 'Todd' AND genre = 'Drama' AND last_name = '12 Poissons'`,
        // `SELECT SUM(id) FROM directors,directors_genres WHERE directors.id = directors_genres.directors_id AND prob < 1 AND last_name = '12 Poissons' AND genre = 'Drama' AND first_name = 'Todd'`,
        // `SELECT SUM(prob) FROM directors_genres,directors WHERE directors.id = directors_genres.directors_id AND prob < 1`,
        // `SELECT MAX(movie_id) FROM roles,movies,actors WHERE actors.id = roles.actor_id AND movies.id = roles.movie_id AND year = 1915 AND gender = 'M' AND last_name = 'Chincheta' AND first_name = 'Michael' AND rank = 5 AND name = '$1,000 Reward' AND rank is null AND year > 1915`,
        // `SELECT MAX(prob) FROM directors_genres,directors WHERE directors.id = directors_genres.directors_id AND genre = 'Drama'`,
        // `SELECT MIN(id) FROM movies,actors,roles WHERE actors.id = roles.actor_id AND movies.id = roles.movie_id AND role = 'wer' AND first_name = 'Michael' AND last_name = 'Chincheta' AND gender = 'M'`,
        // `SELECT MAX(movie_id) FROM movies_genres,movies WHERE movies.id = movies_genres.movie_id AND year > 1915 AND rank = 5 AND year = 1915 AND rank is null`,
        // `SELECT SUM(rank) FROM movies,movies_genres WHERE movies.id = movies_genres.movie_id AND rank is null AND rank = 5 AND name = '$1,000 Reward' AND year = 1915`,
        // `SELECT COUNT(*) FROM directors_genres WHERE directors.id = directors_genres.directors_id AND genre = 'Drama' AND prob < 1`,
        // `SELECT MIN(movie_id) FROM movies_genres,movies WHERE movies.id = movies_genres.movie_id AND year > 1915 AND rank is null AND year = 1915`,
        // `SELECT MAX(id) FROM directors,directors_genres WHERE directors.id = directors_genres.directors_id AND genre = 'Drama' AND prob < 1 AND first_name = 'Todd'`,
        // `SELECT COUNT(*) FROM roles,movies WHERE movies.id = roles.movie_id AND actors.id = roles.actor_id AND rank = 5 AND role = 'wer' AND year > 1915`,
        // `SELECT SUM(movie_id) FROM roles WHERE movies.id = roles.movie_id AND actors.id = roles.actor_id AND role = 'wer'`,
        // `SELECT MAX(prob) FROM directors_genres,directors WHERE directors.id = directors_genres.directors_id AND last_name = '12 Poissons' AND genre = 'Drama' AND first_name = 'Todd'`,
        // `SELECT MAX(id) FROM actors,movies,roles WHERE movies.id = roles.movie_id AND actors.id = roles.actor_id AND name = '$1,000 Reward' AND rank is null AND year = 1915 AND rank = 5 AND last_name = 'Chincheta' AND first_name = 'Michael' AND role = 'wer' AND year > 1915`,
        // `SELECT MIN(movie_id) FROM movies_genres,movies WHERE movies.id = movies_genres.movie_id AND name = '$1,000 Reward' AND rank is null AND year > 1915`,
        // `SELECT MIN(movie_id) FROM movies_genres,movies WHERE movies.id = movies_genres.movie_id AND year > 1915 AND year = 1915 AND rank is null AND rank = 5`,
        // `SELECT MIN(id) FROM directors,movies,movies_directors WHERE movies.id = movies_directors.movie_id AND directors.id = movies_directors.director_id AND year = 1915 AND rank = 5 AND first_name = 'Todd'`,
        // `SELECT SUM(id) FROM movies,roles WHERE movies.id = roles.movie_id AND actors.id = roles.actor_id AND year > 1915`,
        // `SELECT MIN(id) FROM movies,directors,movies_directors WHERE movies.id = movies_directors.movie_id AND directors.id = movies_directors.director_id AND year = 1915 AND movie_id = 60570 AND rank = 5`,
        // `SELECT MIN(id) FROM directors,directors_genres WHERE directors.id = directors_genres.directors_id AND last_name = '12 Poissons' AND genre = 'Drama' AND prob < 1`,
        // `SELECT MAX(director_id) FROM movies_directors WHERE movies.id = movies_directors.movie_id AND directors.id = movies_directors.director_id AND movie_id = 60570 AND director_id = 2`,
        // `SELECT COUNT(*) FROM movies_directors WHERE directors.id = movies_directors.director_id AND movies.id = movies_directors.movie_id AND movie_id = 60570 AND director_id = 2`,

      ],
      //   tpch_sqlserver: [`select 
      //   l_returnflag,
      //   l_linestatus,
      //   sum(l_quantity) as sum_qty,
      //   sum(l_extendedprice) as sum_base_price,
      //   sum(l_extendedprice * (1 - l_discount)) as sum_disc_price,
      //   sum(l_extendedprice * (1 - l_discount) * (1 + l_tax)) as sum_charge,
      //   avg(l_quantity) as avg_qty,
      //   avg(l_extendedprice) as avg_price,
      //   avg(l_discount) as avg_disc,
      //   count(*) as count_order
      // from
      //   lineitem
      // where
      //   l_extendedprice > 100
      // group by
      //   l_returnflag,
      //   l_linestatus
      // order by
      //   l_returnflag,
      //   l_linestatus;`,
      //     `select
      //   l_orderkey,
      //   sum(l_extendedprice * (1 - l_discount)) as revenue,
      //   o_orderdate,
      //   o_shippriority
      // from
      //   customer,
      //   orders,
      //   lineitem
      // where
      //   c_mktsegment = 'BUILDING'
      //   and c_custkey = o_custkey
      //   and l_orderkey = o_orderkey
      //   and o_totalprice > 10
      //   and l_extendedprice > 10
      // group by
      //   l_orderkey,
      //   o_orderdate,
      //   o_shippriority
      // order by
      //   revenue desc,
      //   o_orderdate;`,

      //     `select
      //   o_orderpriority,
      //   count(*) as order_count
      // from
      //   orders
      // where
      //   o_totalprice > 100
      //   and exists (
      //     select
      //       *
      //     from
      //       lineitem
      //     where
      //       l_orderkey = o_orderkey
      //       and l_extendedprice > 100
      //   )
      // group by
      //   o_orderpriority
      // order by
      //   o_orderpriority;`,

      //     `select
      //   n_name,
      //   sum(l_extendedprice * (1 - l_discount)) as revenue
      // from
      //   customer,
      //   orders,
      //   lineitem,
      //   supplier,
      //   nation,
      //   region
      // where
      //   c_custkey = o_custkey
      //   and l_orderkey = o_orderkey
      //   and l_suppkey = s_suppkey
      //   and c_nationkey = s_nationkey
      //   and s_nationkey = n_nationkey
      //   and n_regionkey = r_regionkey
      //   and r_name = 'ASIA'
      //   and o_orderdate >= '1994-01-01'
      //   and o_orderdate < '1995-01-01'
      //   and c_acctbal > 10
      //   and s_acctbal > 20
      // group by
      //   n_name
      // order by
      //   revenue desc;`,

      //     `select
      //   sum(l_extendedprice * l_discount) as revenue
      // from
      //   lineitem
      // where
      //             l_extendedprice > 100;`,

      //     `select
      //   supp_nation,
      //   cust_nation,
      //   l_year,
      //   sum(volume) as revenue
      // from
      //   (
      //     select
      //       n1.n_name as supp_nation,
      //       n2.n_name as cust_nation,
      //       DATEPART(YEAR,l_shipdate) as l_year,
      //       l_extendedprice * (1 - l_discount) as volume
      //     from
      //       supplier,
      //       lineitem,
      //       orders,
      //       customer,
      //       nation n1,
      //       nation n2
      //     where
      //       s_suppkey = l_suppkey
      //       and o_orderkey = l_orderkey
      //       and c_custkey = o_custkey
      //       and s_nationkey = n1.n_nationkey
      //       and c_nationkey = n2.n_nationkey
      //       and (
      //         (n1.n_name = 'FRANCE' and n2.n_name = 'GERMANY')
      //         or (n1.n_name = 'GERMANY' and n2.n_name = 'FRANCE')
      //       )
      //       and l_shipdate between '1995-01-01' and '1996-12-31'
      //       and o_totalprice > 100
      //       and c_acctbal > 10
      //   ) as shipping
      // group by
      //   supp_nation,
      //   cust_nation,
      //   l_year
      // order by
      //   supp_nation,
      //   cust_nation,
      //   l_year;`,
      //     `select
      //   o_year,
      //   sum(case
      //     when nation = 'BRAZIL' then volume
      //     else 0
      //   end) / sum(volume) as mkt_share
      // from
      //   (
      //     select
      //       DATEPART(YEAR,o_orderdate) as o_year,
      //       l_extendedprice * (1 - l_discount) as volume,
      //       n2.n_name as nation
      //     from
      //       part,
      //       supplier,
      //       lineitem,
      //       orders,
      //       customer,
      //       nation n1,
      //       nation n2,
      //       region
      //     where
      //       p_partkey = l_partkey
      //       and s_suppkey = l_suppkey
      //       and l_orderkey = o_orderkey
      //       and o_custkey = c_custkey
      //       and c_nationkey = n1.n_nationkey
      //       and n1.n_regionkey = r_regionkey
      //       and r_name = 'AMERICA'
      //       and s_nationkey = n2.n_nationkey
      //       and o_orderdate between '1995-01-01' and '1996-12-31'
      //       and p_type = 'ECONOMY ANODIZED STEEL'
      //       and s_acctbal > 10
      //       and l_extendedprice > 100
      //   ) as all_nations
      // group by
      //   o_year
      // order by
      //   o_year;`,


      //     `select
      //   n_name,
      //   o_year,
      //   sum(amount) as sum_profit
      // from
      //   (
      //     select
      //       n_name,
      //       DATEPART(YEAR,o_orderdate) as o_year,
      //       l_extendedprice * (1 - l_discount) - ps_supplycost * l_quantity as amount
      //     from
      //       part,
      //       supplier,
      //       lineitem,
      //       partsupp,
      //       orders,
      //       nation
      //     where
      //       s_suppkey = l_suppkey
      //       and ps_suppkey = l_suppkey
      //       and ps_partkey = l_partkey
      //       and p_partkey = l_partkey
      //       and o_orderkey = l_orderkey
      //       and s_nationkey = n_nationkey
      //       and p_name like '%green%'
      //       and s_acctbal > 10
      //       and ps_supplycost > 100
      //   ) as profit
      // group by
      //   n_name,
      //   o_year
      // order by
      //   n_name,
      //   o_year desc;`,


      //     `select
      //   c_custkey,
      //   c_name,
      //   sum(l_extendedprice * (1 - l_discount)) as revenue,
      //   c_acctbal,
      //   n_name,
      //   c_address,
      //   c_phone,
      //   c_comment
      // from
      //   customer,
      //   orders,
      //   lineitem,
      //   nation
      // where
      //   c_custkey = o_custkey
      //   and l_orderkey = o_orderkey
      //   and o_orderdate >= '1993-10-01'
      //   and o_orderdate < '1994-01-01'
      //   and c_nationkey = n_nationkey
      //   and c_acctbal > 10
      //   and l_extendedprice > 100
      // group by
      //   c_custkey,
      //   c_name,
      //   c_acctbal,
      //   c_phone,
      //   n_name,
      //   c_address,
      //   c_comment
      // order by
      //   revenue desc;`,

      //     `select
      //   ps_partkey,
      //   sum(ps_supplycost * ps_availqty) as value
      // from
      //   partsupp,
      //   supplier,
      //   nation
      // where
      //   ps_suppkey = s_suppkey
      //   and s_nationkey = n_nationkey
      //   and n_name = 'GERMANY'
      //   and ps_supplycost > 20
      //   and s_acctbal > 10
      // group by
      //   ps_partkey having
      //     sum(ps_supplycost * ps_availqty) > (
      //       select
      //         sum(ps_supplycost * ps_availqty) * 0.0001000000
      //       from
      //         partsupp,
      //         supplier,
      //         nation
      //       where
      //         ps_suppkey = s_suppkey
      //         and s_nationkey = n_nationkey
      //         and n_name = 'GERMANY'
      //     )
      // order by
      //   value desc;`
      //   ],


      //   nltxt3: `Step 1, perform Table Scan on table ORDERS and filtering on (ORDERS.O_TOTALPRICE>100.00) to get intermediate table T1.
      //   Step 2, perform Table Scan on table LINEITEM and filtering on (LINEITEM.L_EXTENDEDPRICE>100.00) to get intermediate table T2.
      //   Step 3, perform Nested Loops on table T1 and table T2 under condition(LINEITEM.L_ORDERKEY=ORDERS.O_ORDERKEY) to get intermediate table T3.
      //   Step 4, perform sort on table T3 with attribute (ORDERS.O_ORDERPRIORITY in a ascending order) to get intermediate table T4.
      //   Step 5, perform Stream Aggregate on table T4 with grouping on attribute (ORDERS.O_ORDERPRIORITY) to get the final result.`,
      //   nltxt4: `Step 1, perform Table Scan on table NATION.
      //   Step 2, perform sort on table NATION with attribute (NATION.N_NAME in a ascending order) to get intermediate table T1.
      //   Step 3, perform Table Scan on table CUSTOMER and filtering on (CUSTOMER.C_ACCTBAL>10.00) to get intermediate table T2.
      //   Step 4, perform Nested Loops on table T1 and table T2 under condition(CUSTOMER.C_NATIONKEY=NATION.N_NATIONKEY) to get intermediate table T3.
      //   Step 5, perform Table Scan on table SUPPLIER and filtering on (SUPPLIER.S_ACCTBAL>20.00) to get intermediate table T4.
      //   Step 6, hash table T3 and perform Hash Match on table T4 under condition(SUPPLIER.S_NATIONKEY=NATION.N_NATIONKEY) to get intermediate table T5.
      //   Step 7, perform Table Scan on table REGION and filtering on (REGION.R_NAME='ASIA') to get intermediate table T6.
      //   Step 8, hash table T5 and perform Hash Match on table T6 under condition(NATION.N_REGIONKEY=REGION.R_REGIONKEY) to get intermediate table T7.
      //   Step 9, perform Table Scan on table LINEITEM.
      //   Step 10, hash table T7 and perform Hash Match on table LINEITEM under condition(LINEITEM.L_SUPPKEY=SUPPLIER.S_SUPPKEY) to get intermediate table T8.
      //   Step 11, perform Table Scan on table ORDERS and filtering on (ORDERS.O_ORDERDATE>='1994-01-01' AND ORDERS.O_ORDERDATE<'1995-01-01') to get intermediate table T9.
      //   Step 12, hash table T8 and perform Hash Match on table T9 under condition(LINEITEM.L_ORDERKEY=ORDERS.O_ORDERKEY AND CUSTOMER.C_CUSTKEY=ORDERS.O_CUSTKEY) to get intermediate table T10.
      //   Step 13, perform Aggregate(Stream Aggregate) on table T10 with grouping on attribute (NATION.N_NAME) to get intermediate table T11.
      //   Step 14, perform sort on table T11 with attribute (Expr1018 in a descending order) to get the final result.`,
      //   nltxt5: `Step 1, perform Table Scan on table LINEITEM and filtering on (LINEITEM.L_EXTENDEDPRICE>CONVERT_IMPLICITdecimal15) to get intermediate table T1.
      //   Step 2, perform Stream Aggregate on T1 to get the final result.`,

      //   tmpds3: {},
      //   tmpds4: {},
      //   tmpds5: {},
    }
  },
  mutations: {
    setPlanAvailability(state, avail) {
      state.planAvailable = avail
    },
    setNeuralAvailability(state, avail) {
      state.neuralAvailable = avail
    },
    setTreeNodes(state, nodes) {
      state.treenodes = nodes
    },
    setDb(state, db) {
      state.db = db
      localStorage.db = db
    },
    setTables(state, tables) {
      state.tables = tables
    },
    setEmail(state, email) {
      state.email = email
      localStorage.email = email
    },
    setSql(state, sql) {
      state.curSql = sql
    }
  },
  actions: {
    async setDb(context, db) {
      // fetch tables
      let response = await getTables(db)
      context.commit("setTables", response.data)
      // change db if fetch is successful
      context.commit("setDb", db)
    }
  }
})

export {
  store
}
